module.exports = __webpack_public_path__ + "static/media/ic-isometric-belt-squat.1a1b457d.svg";